<template>
  <div v-if="$store.getters.isSafRole && isTypeExpiration && !hasExpirationSetted && hasStatusForApprove">
    <v-tooltip bottom>
      <v-icon small color="orange lighten-1" slot="activator">error</v-icon>
      <span>Falta asignar fecha de vencimiento</span>
    </v-tooltip>
  </div>
  <div v-else></div>
</template>

<script>
import Constants from '../../../common/constants'

export default {
  props: {
    criterion: Object
  },

  computed: {
    isTypeExpiration () {
      return this.criterion.expire
    },
    hasExpirationSetted () {
      return this.criterion.hasOwnProperty('expiration') && this.criterion.expiration.date
    },
    hasStatusForApprove () {
      let status = this.criterion.estadoDisplay
      return status === Constants.REVISADO_OK || status === Constants.NO_PRESENTADO
    }
  }
}
</script>
